import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=16bdd738&scoped=true"
import script from "./fee.vue?vue&type=script&lang=js"
export * from "./fee.vue?vue&type=script&lang=js"
import style0 from "./fee.vue?vue&type=style&index=0&id=16bdd738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bdd738",
  null
  
)

export default component.exports